import { ThemeProvider } from "@emotion/react";
import { responsiveFontSizes } from "@mui/material";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./index.css";
import CookiePolicy from "./Pages/Cookie-Policy";
import OnePager from "./Pages/OnePager";
import PrivacyPolicy from "./Pages/Privacy-Policy";
import Terms from "./Pages/Terms";
import reportWebVitals from "./reportWebVitals";
import { customTheme } from "./theme";
import { isProduction } from "./Utils/environment";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <OnePager />,
      loader: () => ({ pageTitle: "Home", initialTheme: "" }),
    },

    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
      loader: () => ({ pageTitle: "Privacy Policy", initialTheme: "light" }),
    },
    {
      path: "/cookie-policy",
      element: <CookiePolicy />,
      loader: () => ({ pageTitle: "Cookie Policy", initialTheme: "light" }),
    },
    {
      path: "/terms",
      element: <Terms />,
      loader: () => ({ pageTitle: "Terms of Use", initialTheme: "light" }),
    },

    // {
    //   path: "/about",
    //   element: <About />,
    //   loader: () => ({ pageTitle: "About", initialTheme: "light" }),
    // },
    // {
    //   path: "/capabilities",
    //   element: <Capabilities />,
    //   loader: () => ({ pageTitle: "Capabilities", initialTheme: "light" }),
    // },
    // {
    //   path: "/capabilities/:detailSlug",
    //   element: <CapabilitiesDetail />,
    //   loader: () => ({ pageTitle: "", initialTheme: "light" }),
    // },
    // {
    //   path: "/work",
    //   element: <Work />,
    //   loader: () => ({ pageTitle: "Work", initialTheme: "light" }),
    // },
    // {
    //   path: "/studio",
    //   element: <Studio />,
    //   loader: () => ({ pageTitle: "Studio", initialTheme: "light" }),
    // },
    // {
    //   path: "/contact",
    //   element: <Contact />,
    //   loader: () => ({ pageTitle: "Contact", initialTheme: "light" }),
    // },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

// Initialize Firebase
// TODO: Add to ENV variables
const firebaseConfig = {
  apiKey: "AIzaSyAzkVYbUwsMyzKeVn8PKmp7elhQ0v2ZW8s",
  authDomain: "pencil-to-polish-website.firebaseapp.com",
  projectId: "pencil-to-polish-website",
  storageBucket: "pencil-to-polish-website.appspot.com",
  messagingSenderId: "528451522917",
  appId: "1:528451522917:web:643528a4fd6e8afa7ed18c",
  measurementId: "G-PW7R92T17P",
};

// Only initialize analytics on production
if (isProduction()) {
  const app = initializeApp(firebaseConfig);
  getAnalytics(app);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={responsiveFontSizes(customTheme)}>
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
